<!-- Start Page Title Area -->
<div class="page-title-area">
    <div class="container-fluid">
        <div class="page-title-content" >
            <h2 data-aos="fade-down"
            data-aos-easing="linear"
            data-aos-duration="1200">OBD / IVR</h2>
            <ul data-aos="fade-down"
            data-aos-easing="linear"
            data-aos-duration="1200"  >
                <li><a routerLink="/">Home</a></li>
                <li>OBD / IVR</li>
            </ul>
        </div>
    </div>
    
</div>
<section class="team-area ">
    <div class="ai-solution-area pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">

                <div class="media col-lg-5 col-md-6 col-sm-12">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/Speech-Recognition.png" alt="image" />
                    </div>
                </div>

                <div class="text col-lg-5 col-md-6 col-sm-12  order-sm-2 ">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                            Speech Recognition
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                            Utilize advanced speech recognition technology to understand natural language and route callers to the appropriate options.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area-2 pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
                <div class="text col-lg-5 col-md-6 col-sm-12 order-lg-1  order-md-1 order-sm-2">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                              Self-Service Transactions
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 15px ;
                            ">
                           Facilitate basic transactions like bill payments, order tracking, or appointment scheduling through keypad inputs.</p>
                           	
                           	
                           	
                           
                        
                    </div>
                </div>
                <div class="media col-lg-5 col-md-6 col-sm-12  order-lg-2 orde order-sm-1">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/Self-Service.png" alt="image" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">



                <div class="media col-lg-5 col-md-6 col-sm-12  order-lg-1  order-md-1 order-sm-1">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/Call-Routing.png" alt="image" />
                    </div>
                </div>

                <div class="text col-lg-5 col-md-6 col-sm-12  order-lg-2  order-md-2 order-sm-2">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                              Call Routing
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                           Intelligently route callers based on their selections, urgency, or language preference for quicker resolution.
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area-2 pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
                <div class="text col-lg-5 col-md-6 col-sm-12 order-lg-1  order-md-1 order-sm-2">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                           Multilingual Support
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                            Cater to a wider audience in multiple languages.
                        </p>
                    </div>
                </div>
                <div class="media col-lg-5 col-md-6 col-sm-12  order-lg-2 orde order-sm-1">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/Multilingual-Support.png" alt="image" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">



                <div class="media col-lg-5 col-md-6 col-sm-12  order-lg-1  order-md-1 order-sm-1">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/Analytics-2.png" alt="image"  style="max-width: 70% !important; "/>
                    </div>
                </div>

                <div class="text col-lg-5 col-md-6 col-sm-12  order-lg-2  order-md-2 order-sm-2">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                             Analytics & Reporting
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                          Track key metrics like call volume, menu selections, and self-service completion rates to analyse call flow and identify areas for improvement.
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="ai-solution-area-2 pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
                <div class="text col-lg-5 col-md-6 col-sm-12 order-lg-1  order-md-1 order-sm-2">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                            Security
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                           Ensure secure access and data protection for sensitive information collected through the IVR system.
                        </p>
                    </div>
                </div>
                <div class="media col-lg-5 col-md-6 col-sm-12  order-lg-2 orde order-sm-1">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/securities.png" alt="image"  />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">



                <div class="media col-lg-5 col-md-6 col-sm-12  order-lg-1  order-md-1 order-sm-1">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/Customer-Experience.png" alt="image" />
                    </div>
                </div>

                <div class="text col-lg-5 col-md-6 col-sm-12  order-lg-2  order-md-2 order-sm-2">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                              Improved Customer Experience
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                            24/7 availability and self-service options empower customers to resolve issues quickly and conveniently.
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area-2 pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
                <div class="text col-lg-5 col-md-6 col-sm-12 order-lg-1  order-md-1 order-sm-2">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                               Increased Efficiency
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                          Streamline call handling and free up resources for other tasks.
                        </p>
                    </div>
                </div>
                <div class="media col-lg-5 col-md-6 col-sm-12  order-lg-2 orde order-sm-1">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/Increased-Efficiencyy.png" alt="image"  />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">



                <div class="media col-lg-5 col-md-6 col-sm-12  order-lg-1  order-md-1 order-sm-1">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/Enhanced-Brand.png" alt="image" />
                    </div>
                </div>

                <div class="text col-lg-5 col-md-6 col-sm-12  order-lg-2  order-md-2 order-sm-2">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                            Enhanced Brand Image
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                            Demonstrate a commitment to customer satisfaction and accessibility.
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area-2 pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
                <div class="text col-lg-5 col-md-6 col-sm-12 order-lg-1  order-md-1 order-sm-2">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                            Data-Driven Optimization
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                            Analyse IVR performance to continually improve call flow and self-service effectiveness.
                        </p>
                    </div>
                </div>
                <div class="media col-lg-5 col-md-6 col-sm-12  order-lg-2 orde order-sm-1">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/Data-Driven-Optimization.png" alt="image" style="max-width: 75% !important;" />
                    </div>
                </div>
            </div>
        </div>
    </div>
   




    <div class="container-fluid" style="padding-top: 80px ; padding-bottom: 80px;">
      

        <div class="pricing">
            <h3 style="text-align: center; font-size: 24px; ">Pricing</h3>
            <div class="container">
            <table>
                <thead>
                    <tr>
                        <th>Sr. No.</th>
                        <th>Product Name</th>
                        <th>Quantity Slab</th>
                        <th>Amount</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>1</td>
                        <td>Voice</td>
                        <td>10,000 @15 Paise</td>
                        <td>Rs. 1,500/-</td>
                    </tr>
                    <tr>
                        <td>2</td>
                        <td>Voice</td>
                        <td>50,000 @14 Paise</td>
                        <td>Rs. 7,000/-</td>
                    </tr>
                    <tr>
                        <td>3</td>
                        <td>Voice</td>
                        <td>1 Lakh @12 Paise</td>
                        <td>Rs. 12,000/-</td>
                    </tr>
                    <tr>
                        <td>4</td>
                        <td>Voice</td>
                        <td>5 Lakh @9 Paise</td>
                        <td>Rs. 45,000/-</td>
                    </tr>
                    <tr>
                        <td>5</td>
                        <td>Voice</td>
                        <td>10 Lakh @8 Paise</td>
                        <td>Rs. 80,000/-</td>
                    </tr>
                    <tr>
                        <td>6</td>
                        <td>Voice</td>
                        <td>1 Crore @6 Paise</td>
                        <td>Rs. 6,00,000/-</td>
                    </tr>
                </tbody>
            </table>
        </div>
            <h3>Pricing: (GST Exclusive, as applicable)</h3>
        </div>
        
    </div>


</section>
<div class="full-row" #seprator id="seprator">
    <div class="container-fluid">
        <h6>
            Want to Improve the Experience of Your Customers? Our Dedicated Team Is Here to Help You Out!


        </h6>
        <a class="btns btn-primarys" routerLink="/contact">
            CONTACT US
        </a>
    </div>
</div>
